import '../assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Preloader from "../assets/js/preloader.js";
import { NavLink } from "react-router-dom";

import AnimatePage from './animatepage.js';

const newsData = [
    {
        title: "Płetwy Drake x Nocta",
        description: "Nocta zaprezentowała nowe wydanie klapko-płetw.",
        day: "2",
        month: "LUT",
        image: "/img/noctaslide.png",
        link: "./"
    },
    {
        title: "Walentynkowe Force'y",
        description: "Ujrzeliśmy wygląd tegorocznego wydania AF1 z okazji walentynek, uwagę przyciąga Swoosh urozmaicony o dwie wiśnie, premiera jeszcze w lutym.",
        day: "2",
        month: "LUT",
        image: "/img/valentinesday.png",
        link: "./"
    },
    {
        title: "Year Of The Rabbit",
        description: "Według przecieków jeszcze w tym roku ujrzymy kolejną premiere z okazji Chińskiego Nowego Roku, bedzie to 4. wydanie dunków od NIKE z tej okazji.",
        day: "9",
        month: "STY",
        image: "/img2/rabbit.png",
        link: ""
    },
    {
        title: "Kolaboracja Nike SB",
        description: "Najprawdopodohniej w marcu tego roku ujrzymy kolorystyke Pine Green Jordanów 4",
        day: "8",
        month: "STY",
        image: "/img2/pinegreen.png",
        link: ""
    },
    {
        title: "Calm Slides",
        description: "Nike zaprezentowało swoje nowe wydanie klapków, które zdaniem internautów łudząco przypomina Slidesy od Adidasa",
        day: "8",
        month: "STY",
        image: "/img2/calm.png",
        link: ""
    },
    {
        title: "Ekskluzywny drop w Paryżu",
        description: "Nowe wydanie kolaboracji Off-White x Nike Air Force 1 już w 2023 roku!",
        day: "7",
        month: "STY",
        image: "/img2/grey.png",
        link: "./subpages/grey.html"
    }
];


const NewsBlock = ({ title, description, day, month, image, link }) => {
    return (
        <div className="news-block">
            <img src={image} />
            <div>
                <h3>{title}</h3>
                <p>{description}</p>
                <div className="time">{day}<span>{month}</span></div>
                <a href={link || "#"} className={`link ${!link && "un"}`}>CZYTAJ</a>
            </div>
        </div>
    );
};

const News = () => {
    return (
        <div>
            <AnimatePage>
                <section className="home">
                    <section className="news">
                        <section>
                            {newsData.map((newsItem) => {
                                return <NewsBlock key={newsItem.title} {...newsItem} />;
                            })}
                        </section>
                    </section>
                </section>
            </AnimatePage>
        </div>
    );
};

export default News;
